import React from 'react';
import {Checkbox} from 'antd';

import {trb} from '../../../Utilities';

export const CheckboxOnlyFormField = (props) => {
    const label = props.label,
        disabled = props.disabled,
        translate = props.translate,
        className = props.className,
        checkedNumber = props.checkedNumber,
        classNameError = props.classNameError,
        meta = props.meta;

    return <><Checkbox
        disabled={disabled}
        checked={checkedNumber ? props.input.value == 1 : !!props.input.value}
        className={className}
        onChange={props.onChange !== undefined ? (e)=>{props.input.onChange(e); props.onChange(e);} : props.input.onChange}
    >
        <div className='form-field-title'>{translate ? trb(translate) : label}</div>
    </Checkbox>
    <div className={
        classNameError
            ? 'form-field-error ' + classNameError
            : 'form-field-error col-12'}>{meta.touched && (meta.error || meta.submitError)}</div>
    </>;
};
